import type { MessageDescriptor } from 'react-intl';

import { Col } from '@/components/Col';
import { Container } from '@/components/Container';
import { Grid } from '@/components/Grid';
import { LoginRequired } from '@/components/LoginRequired';
import { Row } from '@/components/Row';
import { SideNavigationMenu } from '@/components/SideNavigationMenu';
import { useIsMdDown, useIsSmDown } from '@/hooks/useMedia';
import { AccountLayout } from '@/layouts/AccountLayout';
import type { WithChildren } from '@/lib/types';

import type { CMSLayoutDataProps } from '../Default';
import { Initializer } from './components/Initializer';
interface MyOrdersLayoutProps extends WithChildren {
  cmsData?: CMSLayoutDataProps;
  emailVerification?: string;
  header: MessageDescriptor;
  mobileHeader?: MessageDescriptor;
  withDetails?: boolean;
}

export const MyOrdersLayout = ({
  children,
  cmsData,
  emailVerification,
  withDetails,
}: MyOrdersLayoutProps) => {
  const isMdView = useIsMdDown();
  const isSmView = useIsSmDown();

  return (
    <LoginRequired data-test-id='MyOrdersLayoutLoginRequired'>
      <Initializer emailVerification={emailVerification}>
        <AccountLayout
          backgroundColor='lightGrey'
          cmsData={cmsData}
          data-test-id='MyOrdersLayoutAccountLayout'
        >
          <Container
            backgroundColor='white'
            data-test-id='MyOrdersLayoutContainer'
            marginTop={8}
          >
            <Grid data-test-id='MyOrdersLayoutGrid' gridGap={3} my={2}>
              <Row data-test-id='MyOrdersLayoutRow'>
                {!(withDetails && isMdView) && (
                  <Col
                    data-test-id='MyOrdersLayoutSideNavigationMenuCol'
                    md={3}
                    xs={12}
                    xsOrder={1}
                  >
                    <SideNavigationMenu
                      data-test-id='MyOrdersLayoutSideNavigationMenu'
                      navigationType='myOrders'
                    />
                  </Col>
                )}
                <Col
                  data-test-id='MyOrdersLayoutChildrenCol'
                  md={9}
                  xs={12}
                  xsOrder={!withDetails && isSmView ? -1 : 2}
                >
                  {children}
                </Col>
              </Row>
            </Grid>
          </Container>
        </AccountLayout>
      </Initializer>
    </LoginRequired>
  );
};

MyOrdersLayout.displayName = 'MyOrdersLayout';
